import { render, staticRenderFns } from "./shiftList.vue?vue&type=template&id=cff029ec&scoped=true"
import script from "./shiftList.vue?vue&type=script&lang=js"
export * from "./shiftList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cff029ec",
  null
  
)

export default component.exports